import { PropsWithChildren, useMemo, useState } from 'react';
import { UseFieldArrayUpdate } from 'react-hook-form';
import { createSafeContext } from '@mews/framework';
import { AvailabilityAdjustmentFormValues } from '../types';

interface BlockSetupContextValue {
    addResourceCategoryDisabled: boolean;
    setAddResourceCategoryDisabled: (val: boolean) => void;
    updateRow: UseFieldArrayUpdate<AvailabilityAdjustmentFormValues, 'fieldArrayAvailability'>;
    removeRow: (index: number) => void;
}

const Context = createSafeContext<'BlockSetupContext', BlockSetupContextValue>('BlockSetupContext');

interface BlockSetupContextProviderProps
    extends PropsWithChildren<{}>,
        Pick<BlockSetupContextValue, 'removeRow' | 'updateRow'> {}

export const BlockSetupContextProvider = ({ children, removeRow, updateRow }: BlockSetupContextProviderProps) => {
    // TODO: remove when FeatureFlag.occupancyInBlocksEnabledStage2 is done
    const [addResourceCategoryDisabled, setAddResourceCategoryDisabled] = useState(false);

    const contextValue = useMemo(
        () => ({
            removeRow,
            updateRow,
            addResourceCategoryDisabled,
            setAddResourceCategoryDisabled: (newVal: boolean) => {
                if (newVal !== addResourceCategoryDisabled) {
                    setAddResourceCategoryDisabled(newVal);
                }
            },
        }),
        [removeRow, updateRow, addResourceCategoryDisabled, setAddResourceCategoryDisabled]
    );

    return <Context.BlockSetupContextProvider value={contextValue}>{children}</Context.BlockSetupContextProvider>;
};

export const { useBlockSetupContext } = Context;
